import React from 'react';
import { Testimonial } from '../../../types/index';
import TestimonialCard from './TestimonialCard';

interface TestimonialsTabProps {
  testimonials: Testimonial[];
}

const TestimonialsTab: React.FC<TestimonialsTabProps> = ({ testimonials }) => {
  return (
    <section>
      <h2 className="h5 fw-bold text-dark mb-4">Testimonials Coming soon!!!</h2>
      <div className="d-flex flex-column gap-4">
        {testimonials.map((testimonial, index) => (
          <TestimonialCard key={index} testimonial={testimonial} />
        ))}
      </div>
    </section>
  );
};

export default TestimonialsTab;
